import {
  BackImg,
  ChestImg,
  SleeveLeft,
  SleeveRight,
  SmallTShirt,
} from "../../images";

import { capitalizeFirstWord } from "../../helpers";
import { useShirtArea } from "../../hooks";

import { ErrorWrapper } from "../decorate";

function LogoPlacement({ chest, sleeve, back, setLogoPositions }) {
  const { groupedPositions, locationImages } = useShirtArea();

  const checkObj = {
    chest,
    sleeve,
    back,
  };

  const formatPositionLabel = (key, group) => {
    const parts = key.split("_");
    const lowerGroup = group.toLowerCase();

    const descriptor = parts.find((p) => p.toLowerCase() !== lowerGroup);
    if (descriptor) {
      return descriptor === "center"
        ? `${capitalizeFirstWord(group)} Center`
        : `${capitalizeFirstWord(descriptor)} ${capitalizeFirstWord(group)}`;
    }

    return group === "back"
      ? "Shoulder Blades"
      : parts.map(capitalizeFirstWord).join(" ");
  };

  return (
    <div className="row swap-columns">
      <div className="col-sm-12 text-center mb-3">
        <div className="logo-place">
          <h2>Logo Placement</h2>
        </div>
      </div>
      <div className="col-lg-7 align-self-center">
        <div className="logo-placement-left ml-2">
          {locationImages?.front && (
            <div className="cover-up">
              <img src={locationImages?.front || ChestImg} alt="" />
            </div>
          )}
          {(locationImages?.left || locationImages?.right) && (
            <div className="middle-section">
              {locationImages?.left && (
                <div className="cover-up">
                  <img src={locationImages?.left || SleeveLeft} alt="" />
                </div>
              )}
              {locationImages?.right && (
                <div className="cover-up">
                  <img src={locationImages?.right || SleeveRight} alt="" />
                </div>
              )}
            </div>
          )}
          {locationImages?.back && (
            <div className="cover-up">
              <img src={locationImages?.back || BackImg} alt="" />
            </div>
          )}
        </div>
      </div>
      <div className="col-lg-5 align-self-start">
        <div className="select-by-one-area">
          <ErrorWrapper
            name="placement"
            style={{
              textAlign: "center",
              marginBottom: 30,
              fontSize: 15,
            }}
            Component={() => (
              <div className="d-flex justify-content-center align-items-center gap-2 mb-2">
                <img style={{ height: 25 }} src={SmallTShirt} alt="" />
                <span
                  style={{ fontSize: 21, fontWeight: 600 }}
                  className="mb-0 text-muted"
                >
                  Select Locations
                </span>
              </div>
            )}
          />

          {Object.entries(groupedPositions || {}).map(([group, positions]) => (
            <div
              key={group}
              className="select-place mb-3"
              style={
                checkObj[group]
                  ? { border: "1.5px solid black", boxShadow: "none" }
                  : { border: "1.5px solid transparent" }
              }
            >
              <h5>{capitalizeFirstWord(group)}</h5>
              <div className="d-flex justify-content-center gap-5">
                {positions.map((pos) => (
                  <button
                    key={pos}
                    className={`custom-select-btn ${
                      checkObj?.[group]?.key === pos ? "activeChest" : ""
                    }`}
                    onClick={() => setLogoPositions(group, pos)}
                  >
                    {formatPositionLabel(pos, group)}
                  </button>
                ))}
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}

export default LogoPlacement;
